import { useEffect } from "react";
import { set } from "../../common/util/Immutable";
import { TScene } from "../_generated/NodeTypes";
import {
  useSharedStateWriteOnly,
  useSharedStateWriteOnlyUpdater,
} from "../app/useSharedState";
import { createScene, TAddListChildActionUnion, updateScene } from "../Scene";

enum ServerOpcode {
  ReqSync = -1, // starting_from_version
  RelayTo = -2, // member_id, message
  LoadFile = -3,
}

enum ClientOpcode {
  SendSyncTo = -1, // member_id, starting_from_version
  StartLoadFile = -2,
  EndLoadFile = -3,
  LoadFileRow = -4,
  SetMemberId = -5,
}

export function sendAction(ws: WebSocket, action: TAddListChildActionUnion) {
  // const actionStr = new TextEncoder().encode(JSON.stringify(action));

  // const message = new DataView(new ArrayBuffer(8 + actionStr.byteLength));
  // new Uint8Array(message.buffer).set(actionStr, 8);

  console.log("send", JSON.stringify(action));

  ws.send(JSON.stringify(action));
}

export function sendRelayAction(
  ws: WebSocket,
  memberId: number,
  actionMsg: ArrayBuffer
) {
  const message = new DataView(new ArrayBuffer(8 + 2 + actionMsg.byteLength));
  message.setBigInt64(0, BigInt(ServerOpcode.RelayTo));
  message.setUint16(8, memberId);
  new Uint8Array(message.buffer).set(new Uint8Array(actionMsg), 8 + 2);
  console.log("send", "relay", `to ${memberId}`, message);
  ws.send(message);
}

export function sendSyncRequest(ws: WebSocket, startingFrom: bigint) {
  const message = new DataView(new ArrayBuffer(8 + 8));
  message.setBigInt64(0, BigInt(ServerOpcode.ReqSync));
  message.setBigInt64(8, startingFrom);
  console.log("send", "sync req", `starting from ${startingFrom}`, message);
  ws.send(message);
}

export function sendLoadFileRequest(ws: WebSocket) {
  const message = new DataView(new ArrayBuffer(8));
  message.setBigInt64(0, BigInt(ServerOpcode.LoadFile));
  console.log("send", "loadfile", message);
  ws.send(message);
}

export function receiveAction(
  updScene: (u: (v: TScene) => TScene) => void,
  ws: WebSocket,
  version: bigint,
  bytes: DataView
) {
  console.log("recv action");

  updScene((scene) => {
    if (scene.version < version - BigInt(1)) {
      console.log(
        `scene version ${scene.version} older than action version ${version}`
      );
      sendSyncRequest(ws, scene.version + BigInt(1));

      setTimeout(() => {
        if (scene.version < version) {
          // reload entire file
        }
      }, 8000);

      return scene;
    }

    // console.log(new TextDecoder().decode(bytes));

    const action: TAddListChildActionUnion = JSON.parse(
      new TextDecoder().decode(bytes)
    );

    if (action.action === "add_list_child") {
      action.position = new Uint8Array(Object.values(action.position));
    }

    return set(updateScene(scene, action), "version", version);
  });
}

export function receiveFileRow(
  updLoadingScene: (u: (v: TScene | undefined) => TScene | undefined) => void,
  bytes: DataView
) {
  const t = bytes.getUint16(0);
  const id = new TextDecoder().decode(
    new DataView(bytes.buffer, bytes.byteOffset + 2, 16)
  );
  // const node = deserialize_surface(bytes);

  // return updLoadingScene((scene) =>
  //   scene === undefined
  //     ? undefined
  //     : upd(scene, "nodes", (v) => set(v, id as TAnyNodeID, node))
  // );
}

export function receiveMessage(
  updScene: (u: (v: TScene) => TScene) => void,
  updLoadingScene: (u: (v: TScene | undefined) => TScene | undefined) => void,
  setRoomMemberId: (v: number) => void,
  ws: WebSocket,
  actionMsgLog: ArrayBuffer[], // Mutable, not in Redux state
  bytes: ArrayBuffer
) {
  const view = new DataView(bytes);
  const version = view.getBigInt64(0);

  console.log("recv", bytes);
  console.log(version, new TextDecoder().decode(new Uint8Array(bytes)));

  const opcode = Number(version);
  if (opcode === ClientOpcode.SendSyncTo) {
    const memberId = view.getUint16(8);
    const startingFrom = view.getBigInt64(8 + 2);
    console.log(`recv send sync to ${memberId} starting from ${startingFrom}`);
    for (const msg of actionMsgLog.slice(Number(startingFrom))) {
      if (msg === undefined) {
        return;
      }
      sendRelayAction(ws, memberId, msg);
    }
    return;
  } else if (opcode === ClientOpcode.StartLoadFile) {
    updLoadingScene(() => createScene());
    return;
  } else if (opcode === ClientOpcode.EndLoadFile) {
    let loadingScene: TScene | undefined;
    updLoadingScene((old) => {
      loadingScene = old;
      return undefined;
    });
    if (loadingScene !== undefined) {
      updScene(() => loadingScene!);
    }
    return;
  } else if (opcode === ClientOpcode.LoadFileRow) {
    receiveFileRow(updLoadingScene, new DataView(bytes, 8));
    return;
  } else if (opcode === ClientOpcode.SetMemberId) {
    setRoomMemberId(view.getUint16(8));
    console.log(`my member id ${view.getUint16(8)}`);
    return;
  }

  actionMsgLog[opcode] = bytes;
  receiveAction(updScene, ws, version, new DataView(bytes, 8));
}

export function useEditorConnection() {
  const [, , updServerSocket] = useSharedStateWriteOnlyUpdater("serverSocket");
  const [, , updScene] = useSharedStateWriteOnlyUpdater("scene");
  const [, , updLoadingScene] = useSharedStateWriteOnlyUpdater("loadingScene");
  const [, setRoomMemberId] = useSharedStateWriteOnly("roomMemberId");

  useEffect(() => {
    console.log(1);
    // const ws = new WebSocket("wss://editor.substation.com/0");
    const ws = new WebSocket("wss://127.0.0.1/0");
    ws.binaryType = "arraybuffer";

    // setServerSocket(ws);
    updServerSocket((old) => {
      old.close();
      return ws;
    });

    const actionMsgLog: ArrayBuffer[] = [];
    ws.onmessage = (e) => {
      receiveMessage(
        updScene,
        updLoadingScene,
        setRoomMemberId,
        ws,
        actionMsgLog,
        e.data
      );
    };

    // sendLoadFileRequest(ws);
  }, []);
}
